

var $isNaN = require('./isNaN');

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};




//////////////////
// WEBPACK FOOTER
// ../node_modules/math-intrinsics/sign.js
// module id = ../node_modules/math-intrinsics/sign.js
// module chunks = 0